var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6665,
    cy: 25,
    r: 25,
    fill: "#00A09B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0277 26.3647H30.296V23.617H20.0277V26.3647ZM13.179 28.7559H14.223V21.2304H10.8961V28.7559H13.179ZM36.0961 28.7559H39.423V21.2304H36.0961V28.7559ZM17.7448 32.7793H18.7888V17.207H15.4619V32.7793H17.7448ZM31.5349 32.7793H34.8618V17.207H31.5349V32.7793ZM30.9178 34C30.5744 34 30.3007 33.7257 30.3007 33.3919V27.59H20.0323V33.3919C20.0323 33.7257 19.7539 34 19.4152 34H14.8494C14.506 34 14.2276 33.7257 14.2276 33.3919V29.9812H10.2836C9.94027 29.9812 9.6665 29.7069 9.6665 29.3731V20.6269C9.6665 20.2885 9.94491 20.0188 10.2836 20.0188H14.2276V16.6081C14.2276 16.2698 14.506 16 14.8494 16H19.4152C19.7539 16 20.0323 16.2743 20.0323 16.6081V22.4099H30.3007V16.6081C30.3007 16.2698 30.5791 16 30.9178 16H35.4836C35.827 16 36.1054 16.2743 36.1054 16.6081V20.0188H40.0494C40.3927 20.0188 40.6665 20.2931 40.6665 20.6269V29.3731C40.6665 29.7069 40.3881 29.9812 40.0494 29.9812H36.1054V33.3919C36.1054 33.7257 35.827 34 35.4836 34H30.9178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.4c2a37fdeaefed3299af571922d0b9b1.svg";
export { ForwardRef as ReactComponent };